import { Link, useLocation } from "react-router-dom";
import { ListTodo, TrendingUp, Clock, AlertCircle, Timer, FolderKanban, Settings } from "lucide-react";

const TIMER_ENABLED = import.meta.env.VITE_ENABLE_TIMER === "true";

export function BottomTabBar() {
  const location = useLocation();

  const menuItems = [
    { path: "/tasks", label: "Tasks", icon: ListTodo },
    { path: "/today", label: "Today", icon: Clock },
    { path: "/backlogs", label: "Backlogs", icon: AlertCircle },
    ...(TIMER_ENABLED ? [{ path: "/time-tracking", label: "Time", icon: Timer }] : []),
    { path: "/projects", label: "Projects", icon: FolderKanban },
    { path: "/statistics", label: "Stats", icon: TrendingUp },
  ];

  const isActive = (path: string) => {
    if (path === "/tasks") {
      // Tasks is active for /tasks and its sub-routes like /calendar, /kanban
      return location.pathname === "/tasks" ||
        location.pathname.startsWith("/tasks") ||
        location.pathname === "/calendar" ||
        location.pathname === "/kanban";
    }
    if (path === "/projects") {
      return location.pathname.startsWith("/project/");
    }
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t bg-background md:hidden pb-tab-safe">
      <div className="flex items-center justify-around h-16 px-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex flex-col items-center justify-center gap-1 flex-1 h-full min-w-0"
            >
              <Icon
                className={`h-5 w-5 transition-colors ${
                  isActive(item.path) ? "text-primary" : "text-muted-foreground"
                }`}
              />
              <span
                className={`text-xs font-medium transition-colors ${
                  isActive(item.path) ? "text-primary" : "text-muted-foreground"
                }`}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
        <Link
          to="/settings"
          className="flex flex-col items-center justify-center gap-1 flex-1 h-full min-w-0"
        >
          <Settings
            className={`h-5 w-5 transition-colors ${
              location.pathname.includes("/settings") ? "text-primary" : "text-muted-foreground"
            }`}
          />
          <span
            className={`text-xs font-medium transition-colors ${
              location.pathname.includes("/settings") ? "text-primary" : "text-muted-foreground"
            }`}
          >
            Settings
          </span>
        </Link>
      </div>
    </nav>
  );
}